import { Col, Row, Tabs } from 'antd';
import React from 'react';

import { STATUS_LIST } from '../../enum';
import Button from '../Button';
import TabsContainer from '../TabsContainer';
import LinkText from '../Text/LinkText';
import TripsCommentsTimeline from '../TripsCommentsTimeline';

const COMMENTS_TAB = 'comments';

const TripCommentsSection = props => {
  const { t, trip, onViewMoreComments } = props;
  const HAS_COMMENTS = !!trip.latestComment;
  const CAN_ADD_COMMENT = [
    STATUS_LIST().Status.PENDING,
    STATUS_LIST().Status.DENIED,
    STATUS_LIST().Status.MORE_INFO,
  ].includes(trip.journeyStatus);

  return (
    <TabsContainer activeKey={COMMENTS_TAB}>
      <Tabs.TabPane key={COMMENTS_TAB} tab={t('comments')}>
        {/* Comment */}
        <TripsCommentsTimeline
          t={t}
          comments={HAS_COMMENTS ? [trip.latestComment] : []}
          canAddComment={false}
        />

        {CAN_ADD_COMMENT && !HAS_COMMENTS && (
          <Row justify="center">
            <Button size="xs" onClick={() => onViewMoreComments(trip._id)}>
              {t('addComment')}
            </Button>
          </Row>
        )}
        {HAS_COMMENTS && typeof onViewMoreComments === 'function' && (
          <Row justify="center">
            <Col>
              <LinkText onClick={() => onViewMoreComments(trip._id)}>{t('viewMore')}</LinkText>
            </Col>
          </Row>
        )}
      </Tabs.TabPane>
      )
    </TabsContainer>
  );
};

export default TripCommentsSection;
